module.exports = __webpack_public_path__ + "static/img/tab-banner1.baf9e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/tab-banner1.png
// module id = 5Jps
// module chunks = 1